import { render, staticRenderFns } from "./DexPWAModal.vue?vue&type=template&id=d49b230a&scoped=true&"
import script from "./DexPWAModal.vue?vue&type=script&lang=ts&"
export * from "./DexPWAModal.vue?vue&type=script&lang=ts&"
import style0 from "./DexPWAModal.vue?vue&type=style&index=0&id=d49b230a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49b230a",
  null
  
)

export default component.exports